import { Logger, LogLevel, UserAgentApplication } from 'msal';
import { getChannelParam, getLocale } from '../util';
import AuthProvider from './AuthProvider';
import {
  REACT_APP_INSTANCE,
  REACT_APP_TENANT,
  REACT_APP_CLIENT_ID,
  REACT_APP_SIGN_IN_POLICY,
  REACT_APP_REDIRECT_URI,
  REACT_APP_TOKEN_REDIRECT,
  REACT_APP_MSAL_LOG_LEVEL,
} from '../config';
import { QueryParams } from '../constants';

const instance = REACT_APP_INSTANCE;
const tenant = REACT_APP_TENANT;
const clientId = REACT_APP_CLIENT_ID;
const signInPolicy = REACT_APP_SIGN_IN_POLICY;
const signInAuthority = `https://${instance}/${tenant}/${signInPolicy}`;
const redirectUri = REACT_APP_REDIRECT_URI;
const tokenRedirectUri = REACT_APP_TOKEN_REDIRECT;
const msalLogLevel = REACT_APP_MSAL_LOG_LEVEL;

export const requiresInteraction = (errorMessage) => {
  if (!errorMessage || !errorMessage.length) {
    return false;
  }
  return (
    errorMessage.indexOf('consent_required') > -1 ||
    errorMessage.indexOf('interaction_required') > -1 ||
    errorMessage.indexOf('login_required') > -1
  );
};

export const isIE = () => {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ') > -1;
  const msie11 = ua.indexOf('Trident/') > -1;
  return msie || msie11;
};

export const CONSENT_LOGIN_QUERY_PARAM = {
  OPENID: 'openid',
  PROFILE: 'profile',
  PROMPT: 'login',
  LOCALE: getLocale(),
};

export const getExtraQueryParameters = () => {
  const channel = getChannelParam();
  const extraQueryParameters = {
    ui_locales: CONSENT_LOGIN_QUERY_PARAM.LOCALE,
  };

  // For some reason if channel property exists, even if it is null/undefined,
  // msal defaults to chevrolet channel
  // In order to get no channel msal login, the channel property can not be present
  if (channel) {
    extraQueryParameters[QueryParams.channel] = channel;
  }
  return extraQueryParameters;
};

export const ONP_CONSENT_LOGIN_REQUESTS = {
  LOGIN: {
    scopes: [CONSENT_LOGIN_QUERY_PARAM.OPENID, CONSENT_LOGIN_QUERY_PARAM.PROFILE],
    extraQueryParameters: getExtraQueryParameters(),
    prompt: CONSENT_LOGIN_QUERY_PARAM.PROMPT,
    ACCESS_TOKEN: {
      redirectUri: tokenRedirectUri,
      scopes: [],
    },
  },
};

export const loggerCallback = (logLevel, message) => {
  console.log(message);
};

export const telemetryEmitterCallback = (events) => {
  console.log('Telemetry Events:', events);
};

export const msalApp = new UserAgentApplication({
  auth: {
    clientId: clientId,
    authority: signInAuthority,
    redirectUri: redirectUri,
    validateAuthority: false,
    postLogoutRedirectUri: 'window.location.origin',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: isIE(),
  },
  system: {
    navigateFrameWait: 500,
    logger: new Logger(loggerCallback, {
      level: LogLevel[msalLogLevel],
      piiLoggingEnabled: true,
    }),
    telemetry: {
      applicationName: 'onp-consent-subscriberui',
      applicationVersion: '0.1.0-SNAPSHOT',
      telemetryEmitter: telemetryEmitterCallback,
    },
  },
});

export { AuthProvider };
